import T from 'i18n-react';
import { get as lodashGet } from 'lodash';

export default class {
  constructor() {
    this.users = {};
    this.companies = {};
    this.roles = {};
  }

  setMappings(mappings) {
    Object.assign(this.users, mappings.users);
    Object.assign(this.companies, mappings.companies);
    Object.assign(this.roles, mappings.roles);
  }

  getDisplayName(id) {
    const item = this.users[id] || this.companies[id] || this.roles[id];
    return item && item.name;
  }

  getAssigneesDisplayName(assignees) {
    if (!assignees) {
      return T.translate('assignment.assigneeUnspecified');
    }

    return assignees.map((assignee) => {
      const { id } = assignee;
      const assigneeName = lodashGet(this.users[id], 'name', null);
      const companyName = lodashGet(this.users[id], 'company.name', null);
      if (companyName) {
        return `${assigneeName} (${companyName})`;
      }

      return assigneeName;
    }).filter((name) => !!name).join(', ');
  }

  getCompanyDisplayNameByUserId(userId) {
    let companyName = '';

    if (userId) {
      companyName = lodashGet(this.users[userId], 'company.name', '');
    }

    return companyName;
  }
}
